import { makeStyles } from 'tss-react/mui';

const useStylesFooterContainer: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  footerContainer: {
    height: 0,
    width: '100%',
  },
  footerContainerBottomOffset: {
    height: 85,
  },
  footerContainerInvisible: {
    display: 'none',
  },
}));

export default useStylesFooterContainer;
